import React from "react"
import moment from "moment"

/* Field names */
const FIELDS = {
    link: "Привязан к заказу 1С",
    oneCStatus: "Статус в 1С",
    deliveryStatus: "Статус заказа",
    deliveryMethod: "Способ доставки",
    paymentStatus: "Статус оплаты",
    paymentMethod: "Способ оплаты",
    comment: "Комментарий",
    sale_percent: "Скидка",
    total: "Сумма заказа",
    item_added: "Добавлен товар",
    item_removed: "Удален товар",
    item_quantity: "Количество",
    item_price: "Цена"
}

/* Status values */
const VALUES = {
    deliveryStatus: { new: "Новый", pending: "В обработке", ontheway: "В пути", completed: "Завершен", finish: "Завершен (Склад)", canceled: "Отменен" },
    paymentStatus: { paid: "Оплачен", notpaid: "Не оплачен", reserve: "Резерв" },
    paymentMethod: { kaspiqr: "Каспи QR", invoicepayment: "Счет на оплату", cash: "Наличными", debt: "Долг", qr: "QR" },
    deliveryMethod: { delivery: "Доставка", pickup: "Самовывоз", self: "Самовывоз" }
}

const empty = v => v === null || v === undefined || v === ""
const label = (field, v) => empty(v) ? "—" : ((VALUES[field] && VALUES[field][v]) || v)

/*
    Widget Order History
*/
const OrderHistory = ({ history }) => {

    if (!Array.isArray(history) || history.length === 0) {
        return null
    }

    return (
        <div className="order-history">
            <h2>История изменений</h2>
            {history.map(row => (
                <div key={row.id} className="order-history-row">
                    <div className="order-history-meta">
                        <span className={`tag ${row.source === '1c' ? 'darkblue' : 'purple'}`}>{row.source === '1c' ? '1С' : (row.adminName || 'Админ')}</span>
                        <span className="order-history-date">{moment(row.createdAt).format("DD.MM.YYYY HH:mm")}</span>
                    </div>
                    <div className="order-history-text">
                        <b>{FIELDS[row.field] || row.field}</b>
                        {row.product ? <span>: {row.product}</span> : null}
                        {row.field === 'item_added' || (row.field === 'link' && empty(row.oldValue))
                            ? <span> — {label(row.field, row.newValue)}</span>
                            : row.field === 'item_removed'
                                ? <span> — {label(row.field, row.oldValue)}</span>
                                : <span> — {label(row.field, row.oldValue)} → {label(row.field, row.newValue)}</span>}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default OrderHistory
